export const STAFF_REQUEST_STATUS_CREATED = 'created'
export const STAFF_REQUEST_STATUS_CANCELED = 'canceled'
export const STAFF_REQUEST_STATUS_DONE = 'done'
export const STAFF_REQUEST_STATUS_SENT = 'sent'
export const STAFF_REQUEST_STATUS_REGISTERED = 'registered'
export const STAFF_REQUEST_STATUS_REJECTED = 'rejected'
export const STAFF_REQUEST_STATUS_WORKER_TYPE_CONFLICT = 'worker-type-conflict'


export const STAFF_REQUEST_STATUS_COLLECTION = {
  STAFF_REQUEST_STATUS_CREATED,
  STAFF_REQUEST_STATUS_CANCELED,
  STAFF_REQUEST_STATUS_DONE,
  STAFF_REQUEST_STATUS_SENT,
  STAFF_REQUEST_STATUS_REGISTERED,
  STAFF_REQUEST_STATUS_REJECTED,
  STAFF_REQUEST_STATUS_WORKER_TYPE_CONFLICT,
}

export const STAFF_REQUEST_STATUS_LABEL_COLLECTION = {
  [STAFF_REQUEST_STATUS_CREATED]: 'Новый',
  [STAFF_REQUEST_STATUS_CANCELED]: 'Отменен',
  [STAFF_REQUEST_STATUS_DONE]: 'В моих исполнителях',
  [STAFF_REQUEST_STATUS_SENT]: 'Ожидает регистрации',
  [STAFF_REQUEST_STATUS_WORKER_TYPE_CONFLICT]: 'Связь с соискателем',
  [STAFF_REQUEST_STATUS_REJECTED]: 'Отказ',
  [STAFF_REQUEST_STATUS_REGISTERED]: 'Ожидает активации',
}
export const STAFF_REQUEST_STATUS_SELECT_OPTIONS = [
  {
    'id': STAFF_REQUEST_STATUS_SENT,
    'label': STAFF_REQUEST_STATUS_LABEL_COLLECTION[STAFF_REQUEST_STATUS_SENT]
  },
  {
    'id': STAFF_REQUEST_STATUS_REGISTERED,
    'label': STAFF_REQUEST_STATUS_LABEL_COLLECTION[STAFF_REQUEST_STATUS_REGISTERED]
  },
  {
    'id': STAFF_REQUEST_STATUS_WORKER_TYPE_CONFLICT,
    'label': STAFF_REQUEST_STATUS_LABEL_COLLECTION[STAFF_REQUEST_STATUS_WORKER_TYPE_CONFLICT]
  },
  {
    'id': STAFF_REQUEST_STATUS_DONE,
    'label': STAFF_REQUEST_STATUS_LABEL_COLLECTION[STAFF_REQUEST_STATUS_DONE]
  },
]

export const getStaffRequestStatusLabel = (status) => {
  if (!STAFF_REQUEST_STATUS_LABEL_COLLECTION[status]) {
    return status
  }
  return STAFF_REQUEST_STATUS_LABEL_COLLECTION[status]
}

export const staffRequestHasConflict = (staffRequest) =>
  staffRequest.status === STAFF_REQUEST_STATUS_WORKER_TYPE_CONFLICT

export const staffRequestCreated = (staffRequest) =>
  staffRequest.status === STAFF_REQUEST_STATUS_CREATED


export const staffRequestSent = (staffRequest) =>
  staffRequest.status === STAFF_REQUEST_STATUS_SENT

export const staffRequestCanReInvite = (staffRequest) =>
  !!staffRequestSent(staffRequest) || !!staffRequestCreated(staffRequest)
